import Middleware from './models/Middleware'
import { loadMiddleware, saveModelBindings, removeBinding, declassifyMiddleware } from '@/api/environment'

export default {

  namespaced: true,

  state: {
    middleware: new Middleware
  },

  mutations: {
    ...Middleware.mutations()
  },

  actions: {
    loadMiddleware: ({commit}, payload) => new Promise((resolve, reject) => {
      loadMiddleware(payload, ({data}) => {
        commit('setMiddleware', data)
        resolve()
      }, reject)
    }),
    saveBindings: ({commit, state}, bindings) => new Promise((resolve, reject) => {
      saveModelBindings({
        bindings,
        middlewareId: state.middleware.id
      }, ({data}) => {
        resolve()
      }, reject)
    }),
    removeBinding: ({commit, state}, modelId) => new Promise((resolve, reject) => {
      removeBinding({
        modelId,
        middlewareId: state.middleware.id
      }, ({data}) => {
        commit('removeBinding', modelId)
        resolve()
      }, reject)
    }),
    declassify: ({commit, state}) => new Promise((resolve, reject) => {
      declassifyMiddleware(state.middleware.id, ({data}) => {
        commit('setMiddleware', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    middleware: state => state.middleware
  }

}
